var map = {
	"./cws": 81,
	"./cws/": 81,
	"./cws/assets/CWS_Weihnachtskarte_Healthcare.png": 133,
	"./cws/assets/CWS_Weihnachtskarte_Workwear.png": 134,
	"./cws/assets/cws-workwear-logo.png": 135,
	"./cws/assets/fonts/AlFresco.ttf": 138,
	"./cws/assets/fonts/SuisseIntl-Bold.otf": 136,
	"./cws/assets/fonts/SuisseIntl-Regular.otf": 137,
	"./cws/index": 81,
	"./cws/index.ts": 81,
	"./cws/render": 85,
	"./cws/render.ts": 85,
	"./cws/render/christmas": 86,
	"./cws/render/christmas.ts": 86,
	"./cws/render/shared": 59,
	"./cws/render/shared.ts": 59,
	"./cws/templates": 84,
	"./cws/templates.ts": 84,
	"./cws/texts": 68,
	"./cws/texts.ts": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 277;